import React, { useEffect, useState } from "react";
import "../styles/Navbar.css";

const Navbar = () => {
  const [active, setActive] = useState("home");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);

      const sections = document.querySelectorAll("section");
      sections.forEach((section) => {
        const top = window.scrollY;
        const offset = section.offsetTop - 140;
        const height = section.offsetHeight;
        const id = section.getAttribute("id");
        if (top >= offset && top < offset + height) setActive(id);
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const links = ["home", "about", "skills", "projects", "contact"];

  return (
    <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
      <div className="nav-inner">
        {/* Logo mark */}
        <a href="#home" className="nav-logo" aria-label="Roy Zaouk home">
          <span className="nav-logo-bracket">[</span>
          <span className="nav-logo-text">RZ</span>
          <span className="nav-logo-bracket">]</span>
        </a>

        {/* Links */}
        <ul className="nav-menu">
          {links.map((id) => (
            <li key={id}>
              <a
                href={`#${id}`}
                className={active === id ? "active" : ""}
                aria-current={active === id ? "page" : undefined}
              >
                <span className="nav-link-num">
                  {String(links.indexOf(id) + 1).padStart(2, "0")}.
                </span>
                <span className="nav-link-label">
                  {id.charAt(0).toUpperCase() + id.slice(1)}
                </span>
              </a>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <a href="#contact" className="nav-cta">
          Hire Me
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
